<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="9" vs-md="6" vs-xs="12">
        <div class="sub-header align-self-center d-sm-flex w-100 rounded">
          <div class="w-sm-100">
            <h4 class="mb-0">Dashboard</h4>
            <p>Welcome to liner admin panel</p>
            <vs-button
              color="primary"
              class="whitespace-no-wrap mt-2"
              type="filled"
              >Get Started <i class="fas fa-arrow-right"></i
            ></vs-button>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-md="6" vs-xs="12">
        <vue-apex-charts
          class="mt-3"
          height="100"
          type="bar"
          :options="ChartOptions.headerchart.options"
          :series="ChartOptions.headerchart.series"
        ></vue-apex-charts>
      </vs-col>
    </div>
    <div class="vs-row">
      <vs-col vs-lg="4"  vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-b-5 border-info"
        >
          <div class="vs-card--content p-0">
            <div class="items-center px-3">
              <div class="card-liner-content text-center text-info p-4">
                <h1 class="card-title m-0 font-medium">3,740,591</h1>
                <h6>Cases</h6>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-success border-b-5 border-info"
        >
          <div class="vs-card--content p-0">
            <div class="items-center px-3">
              <div class="card-liner-content text-center text-success p-4">
                <h1 class="card-title m-0 font-medium">1,247,377</h1>
                <h6>Recovered</h6>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-xs="12">
        <div
          class="con-vs-card cardx overflow-hidden border bottom border-danger border-b-5 border-info"
        >
          <div class="vs-card--content p-0">
            <div class="items-center px-3">
              <div class="card-liner-content text-center text-danger p-4">
                <h1 class="card-title m-0 font-medium">258,509</h1>
                <h6>Death</h6>
              </div>
            </div>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content">
            <chartjs-line-chart
              :height="200"
              :data="ChartOptions.mainbarchart.data"
              :options="ChartOptions.mainbarchart.options"
            ></chartjs-line-chart>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Cases by Country</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <vs-table stripe :data="coronacases">
              <template slot="thead">
                <vs-th>Country</vs-th>
                <vs-th>Active Cases </vs-th>
                <vs-th>Death </vs-th>
              </template>
              <template>
                <vs-tr
                  class="border top"
                  :key="indextr"
                  v-for="(coronacase, indextr) in coronacases"
                >
                  <vs-td :data="coronacase.country">{{
                    coronacase.country
                  }}</vs-td>
                  <vs-td :data="coronacase.active">
                    {{ coronacase.active }}
                  </vs-td>
                  <vs-td :data="coronacase.death">
                    {{ coronacase.death }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Symptoms of COVID-19</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <vs-table stripe :data="symptoms">
              <template>
                <vs-tr
                  class="border top"
                  :key="indextr"
                  v-for="(symptom, indextr) in symptoms"
                >
                  <vs-td :data="symptom.title">
                    <a
                      :href="symptom.link"
                      class="mb-0 font-bold float-left flex w-full text-primary"
                    >
                      {{ symptom.title }}
                      <i class="fas fa-arrow-right ml-auto my-auto"></i></a
                  ></vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Prevention of COVID-19</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <vs-table stripe :data="preventions">
              <template>
                <vs-tr
                  class="border top"
                  :key="indextr"
                  v-for="(prevention, indextr) in preventions"
                >
                  <vs-td :data="prevention.title">
                    <a
                      :href="prevention.link"
                      class="mb-0 font-bold float-left flex w-full text-primary"
                    >
                      {{ prevention.title }}
                      <i class="fas fa-arrow-right ml-auto my-auto"></i></a
                  ></vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Q&A on coronaviruses (COVID-19)</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <vs-collapse accordion>
              <vs-collapse-item icon-arrow="add" open>
                <div slot="header">What is a coronavirus?</div>
                Coronaviruses are a large family of viruses which may cause
                illness in animals or humans. In humans, several coronaviruses
                are known to cause respiratory infections ranging from the
                common cold to more severe diseases such as Middle East
                Respiratory Syndrome (MERS) and Severe Acute Respiratory
                Syndrome (SARS). The most recently discovered coronavirus causes
                coronavirus disease COVID-19.
              </vs-collapse-item>
              <vs-collapse-item icon-arrow="add">
                <div slot="header">What is COVID-19?</div>
                COVID-19 is the infectious disease caused by the most recently
                discovered coronavirus. This new virus and disease were unknown
                before the outbreak began in Wuhan, China, in December 2019.
                COVID-19 is now a pandemic affecting many countries globally.
              </vs-collapse-item>
              <vs-collapse-item icon-arrow="add">
                <div slot="header">What are the symptoms of COVID-19?</div>
                The most common symptoms of COVID-19 are fever, dry cough, and
                tiredness. Other symptoms that are less common and may affect
                some patients include aches and pains, nasal congestion,
                headache, conjunctivitis, sore throat, diarrhea, loss of taste
                or smell or a rash on skin or discoloration of fingers or toes.
                These symptoms are usually mild and begin gradually. Some people
                become infected but only have very mild symptoms.
                <br /><br />
                Most people (about 80%) recover from the disease without needing
                hospital treatment. Around 1 out of every 5 people who gets
                COVID-19 becomes seriously ill and develops difficulty
                breathing. Older people, and those with underlying medical
                problems like high blood pressure, heart and lung problems,
                diabetes, or cancer, are at higher risk of developing serious
                illness. However, anyone can catch COVID-19 and become seriously
                ill. People of all ages who experience fever and/or cough
                associated withdifficulty breathing/shortness of breath, chest
                pain/pressure, or loss of speech or movement should seek medical
                attention immediately. If possible, it is recommended to call
                the health care provider or facility first, so the patient can
                be directed to the right clinic.
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import ChartjsLineChart from "../components/chartjs/ChartjsLineChart.vue";
import PickProgressBar from "../components/PickProgressBar.vue";
import VueApexCharts from "vue-apexcharts";
import CovidChart from "@/demo-data/Covid.js";
export default {
  components: {
    ChartjsLineChart,
    VueApexCharts,
    PickProgressBar,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      ChartOptions: CovidChart[0],
      coronacases: [
        {
          country: "USA",
          active: "964,817",
          death: "72,275",
        },
        {
          country: "Canada",
          active: "31,010",
          death: "4,043",
        },
        {
          country: "Mexico",
          active: "6,708",
          death: "2,507",
        },
        {
          country: "Dominican Republic",
          active: "6,221",
          death: "354",
        },
        {
          country: "Panama",
          active: "6,490",
          death: "210",
        },
        {
          country: "Cuba",
          active: "5,345",
          death: "323",
        },
        {
          country: "Honduras",
          active: "5,555",
          death: "657",
        },
      ],
      symptoms: [
        {
          title: "France",
          link: "#",
        },
        {
          title: "Tiredness",
          link: "#",
        },
        {
          title: "Dry Cough",
          link: "#",
        },
        {
          title: "Aches and Pains",
          link: "#",
        },
        {
          title: "Nasal Congestion",
          link: "#",
        },
        {
          title: "Runny Nose",
          link: "#",
        },
        {
          title: "Sore Throat",
          link: "#",
        },
      ],
      preventions: [
        {
          title: "Stay home",
          link: "#",
        },
        {
          title: "Keep a safe distance",
          link: "#",
        },
        {
          title: "Wash hands often",
          link: "#",
        },
        {
          title: "Cover your cough",
          link: "#",
        },
        {
          title: "Sick? Call the helpline",
          link: "#",
        },
        {
          title: "Cover your nose",
          link: "#",
        },
        {
          title: "Follow local health authority",
          link: "#",
        },
      ],
      rows: [
        {
          country: "France",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "United States",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "China",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Spain",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Italy",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
      ],
    };
  },
};
</script>